var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},[_c('Steps',{attrs:{"active":_vm.value,"active-color":"#DA3738"}},_vm._l((_vm.stepList),function(item,index){return _c('Step',{key:index},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }